import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom'
import { BASE_URL } from '../../constant';
import { fetchCategoryProducts } from '../../redux/actions/CategoryActions';

const CategoryDetails = () => {
    const dispatch = useDispatch();
    let { pathname } = useLocation();
    pathname = pathname.split("/").pop();

    const cleanSlug = pathname.replace(/\.html$/, '');

    // Fetch products for the specific categoryId
    const products = useSelector((state) => state.categories.categoryProducts[cleanSlug]) || [];

    useEffect(() => {
        if (pathname) {
            dispatch(fetchCategoryProducts(cleanSlug));
        }
    }, [dispatch, pathname]);

    // Function to calculate the discount percentage
    const getDiscountPercentage = (regularPrice, salePrice) => {
        if (regularPrice && salePrice && regularPrice > salePrice) {
            return ((regularPrice - salePrice) / regularPrice) * 100;
        }
        return 0;
    };

    // Function to get the lowest sale price from the pro_var array
    const getLowestSalePrice = (pro_var) => {
        if (pro_var && pro_var.length > 0) {
            const prices = pro_var.map((variant) => parseFloat(variant.sale_price)); // Assuming the sale_price is in the "sale_price" field of each variant
            const lowestPrice = Math.min(...prices);
            return lowestPrice;
        }
        return null;
    };

    return (
        <div className={`section__container allProducts__container`}>
            <div className={'BreadCrumb'}>
                    <Link to={'/'} className={'BreadCrumbLink_breadCrumb'}>Home</Link>
                    <Link to={'/'} className={'BreadCrumbLink_breadCrumb'}>Categories</Link>
                    <Link to={'/'} className={'BreadCrumbLink_breadCrumb'}>{pathname}</Link>
            </div>
            <div className='section_gridWrapper'>
                {products.length === 0 ? (
                    <div>No products available.</div>
                ) : ( 
                <>
                    {products.map((product, index) => {
                        const discount = getDiscountPercentage(product.regular_price, product.sale_price); // Calculate discount
                        const lowestPrice = getLowestSalePrice(product.pro_var); // Get the lowest sale price from pro_var array
                        return (
                            <div key={index} className={`product_card`}>
                                <Link to={`/product/${product.slug}`}>
                                    <div className={`product_thumbnail_box`}>
                                        <img src={`${BASE_URL}${product.thumbnail}`} alt={product.name}/>
                                    </div>

                                    <div className='product_card_details'>
                                        <div className='productCard_title'>{product.title}</div>
                                        <div className='productCard_price_wrapper'>
                                        {lowestPrice !== null ? (
                                            <span  className='price_regular'>Starting @ <span className='price_sale'>₹{lowestPrice}</span></span>
                                        ) : product.sale_price ? (
                                            <>
                                                <div className='priceRow'>
                                                    <span className='price_regular'>MRP </span> <span className='price_regular strike'>₹{product.regular_price}</span>
                                                </div>
                                                <div className='priceRow'>
                                                    <span className='price_sale'>₹{product.sale_price}</span> <span className='price_discount'>({discount.toFixed(0)}%{"\n"}OFF)</span>     
                                                </div>
                                            </>
                                        ) : (
                                            <span className='price_regular'>₹{product.regular_price}</span>
                                        )}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )
                    })}
                </>
                )}
            </div>
        </div>
    )
}

export default CategoryDetails